import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import $ from 'jquery';
import 'datatables.net'; // Import DataTables

const Pengaturan = () => {
    const [data, setData] = useState([]); // State untuk menyimpan daftar kelas
    const [error, setError] = useState('');
    const navigate = useNavigate();

    useEffect(() => {
        const fetchKelas = async () => {
            try {
                // Kirim request ke server dengan header level user
                const response = await fetch(`${process.env.REACT_APP_BASE_URL}/admin/ppdb/getpeserta`, {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${localStorage.getItem('authToken')}`,
                    },
                });

                if (!response.ok) {
                    throw new Error("Failed to fetch kelas");
                }

                const data = await response.json();
                console.log(data);
                // Menyimpan data kelas ke dalam state
                setData(data.data); 
            } catch (error) {
                setError(error.message || 'Something went wrong');
            }
        };
        fetchKelas();
    }, []);

    useEffect(() => {
        // Pastikan DataTable hanya diinisialisasi sekali
        if (data.length > 0) {
            // Hancurkan DataTable jika sudah ada sebelum inisialisasi ulang
            if ($.fn.dataTable.isDataTable('.table')) {
                $('.table').DataTable().destroy(); // Menghancurkan DataTable yang lama
            }

            // Inisialisasi DataTable
            $('.table').DataTable({
                "dom": "<'row'<'col-6 col-sm-6 col-md-9'f><'col-6 col-sm-6 col-md-2 'B><'col-sm-6 col-md-1 float-right'l>><'row'<'col-sm-12'tr>><'row'<'col-sm-12 col-md-10'p><'col-sm-12 col-md-2'i>>", // Add 'B' in the appropriate position
                "language": {
                    "search": "",
                    "lengthMenu": "_MENU_"
                },
            });
        }

       
    }, [data]); // Inisialisasi ulang hanya ketika `kelas` berubah

    return (
        <div>
            <div className="pc-container">
                <div className="pc-content">
                    <div className="row">
                        <div className="col-xl-12 col-md-12">
                            <div className="card"> <div className="card-header">
                                <a href='/admin/ppdb/peserta/baru/baru' className="btn btn-secondary d-inline-flex">
                                <i className="ti ti-plus me-1"></i> Tambah Peserta</a>
                                </div>

                                <div className="card-body">
                               
                                    {/* Tabel kelas */}
                                    <table className="table table-hover datatable-table">  
                                        <thead>    
                                            <tr>      
                                                <th width="50">#</th>  
                                                <th scope="col">NO WhatsApp</th>       
                                                <th scope="col">Nama</th>      
                                                <th width="50"><center>Status</center></th>  
                                                <th width="50"><center>Action</center></th>      
                                            </tr>  
                                        </thead>  
                                        <tbody>
                                            {/* Render data kelas */}
                                            {data.map((item, index) => (
                                                <tr key={item.wa_number}>
                                                    <td scope="row">{index + 1}</td>  
                                                    <td><b>{item.wa_number}</b></td>  
                                                    <td><b>{item.nama}</b></td>  
                                                    <td><center></center></td>  {/* Asumsi ada jumlah_pd */}
                                                    <td><a href={`/admin/ppdb/peserta/baru/`+item.wa_number} className="avtar avtar-xs mx-1 btn-link-secondary"><i className="ti ti-eye f-20"></i> </a><a href="#" className="avtar avtar-xs mx-1 btn-link-secondary"><i className="ti ti-edit f-20"></i> </a><a href="#" className="avtar avtar-xs mx-1 btn-link-secondary"><i className="ti ti-trash f-20"></i></a></td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                    {/* Tampilkan error jika ada */}
                                    {error && <div className="alert alert-danger">{error}</div>}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Pengaturan;
